// extracted by mini-css-extract-plugin
export default {"modal":"C3ikObX8","externalLink":"U_p9HKBd","btns":"Hl3uDkkU","partnerLink":"DDclKLUq","desktop":"desktop"};